import { brandPalette } from "../../constants/brandPalette";
/** Shared MainModel + react-select styling for admin forms (matches Add student). */

export const adminModalContentProps = {
  dir: "ltr",
  bg: brandPalette.cream,
  borderRadius: "16px",
  overflow: "hidden",
  boxShadow: "2xl",
};

export const adminModalHeaderProps = {
  px: 8,
  pt: 8,
  pb: 6,
  borderBottom: "1px solid rgba(214, 206, 192, 0.5)",
};

export const adminModalBodyProps = { px: 8, py: 8 };

/**
 * @param {{ hasError?: boolean }} [opts]
 */
export const adminSelectStyles = (opts = {}) => {
  const { hasError } = opts;
  return {
    control: (styles, state) => ({
      ...styles,
      width: "100%",
      backgroundColor: brandPalette.cream,
      color: "#1e1b17",
      borderRadius: "12px",
      borderColor: hasError
        ? "#E53E3E"
        : state.isFocused
          ? brandPalette.primary
          : brandPalette.stone,
      borderWidth: "1px",
      boxShadow: state.isFocused ? "0 0 0 1px rgba(91, 13, 22, 0.22)" : "none",
      minHeight: "42px",
      ":hover": {
        borderColor: hasError ? "#E53E3E" : brandPalette.primary,
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
    placeholder: (styles) => ({
      ...styles,
      color: brandPalette.taupe,
      fontWeight: 600,
      fontSize: "14px",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#1e1b17",
      fontWeight: 600,
      fontSize: "14px",
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "rgba(91, 13, 22, 0.12)",
      borderRadius: "8px",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: brandPalette.secondary,
      fontWeight: 600,
      fontSize: "13px",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: brandPalette.primary,
      ":hover": { backgroundColor: "rgba(91, 13, 22, 0.2)", color: brandPalette.secondary },
    }),
    menu: (styles) => ({
      ...styles,
      borderRadius: "12px",
      overflow: "hidden",
      border: `1px solid ${brandPalette.stone}`,
      boxShadow: "0 16px 40px rgba(91, 13, 22, 0.18)",
      zIndex: 50,
    }),
    option: (styles, state) => ({
      ...styles,
      fontSize: "14px",
      fontWeight: state.isSelected ? 800 : 600,
      color: state.isSelected ? brandPalette.cream : brandPalette.secondary,
      backgroundColor: state.isSelected
        ? brandPalette.secondary
        : state.isFocused
          ? "rgba(247, 242, 236, 0.75)"
          : "transparent",
      ":active": {
        backgroundColor: "rgba(214, 206, 192, 0.7)",
      },
    }),
  };
};

/** Menu row: off-white highlight + burgundy text (not inverted burgundy fill). */
const pillOptionHighlightBg = "rgba(245, 239, 233, 0.98)";

/**
 * Pill-shaped react-select — group filter style (pill control; menu options use off-white selected state).
 * @param {{ menuZIndex?: number }} [opts] — raise inside modals so the menu appears above the overlay (e.g. 50).
 */
export const adminPillSelectStyles = (opts = {}) => {
  const { menuZIndex = 20 } = opts;
  return {
    control: (styles, state) => ({
      ...styles,
      width: "100%",
      minHeight: "40px",
      backgroundColor: "rgba(255,255,255,0.75)",
      borderColor: state.isFocused ? brandPalette.primary : brandPalette.stone,
      borderWidth: "1px",
      borderRadius: "9999px",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(91, 13, 22, 0.12)" : "none",
      cursor: "pointer",
      ":hover": {
        borderColor: brandPalette.primary,
      },
    }),
    valueContainer: (styles) => ({
      ...styles,
      paddingLeft: "12px",
      paddingRight: "8px",
    }),
    placeholder: (styles) => ({
      ...styles,
      color: "rgba(30, 27, 23, 0.55)",
      fontWeight: 600,
      fontSize: "14px",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: brandPalette.secondary,
      fontWeight: 700,
      fontSize: "14px",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (styles, state) => ({
      ...styles,
      color: state.isFocused ? brandPalette.primary : "rgba(91, 13, 22, 0.7)",
      ":hover": { color: brandPalette.primary },
    }),
    menu: (styles) => ({
      ...styles,
      borderRadius: "16px",
      overflow: "hidden",
      border: `1px solid ${brandPalette.stone}`,
      boxShadow: "0 16px 40px rgba(91, 13, 22, 0.18)",
      zIndex: menuZIndex,
    }),
    menuList: (styles) => ({
      ...styles,
      padding: "6px",
      backgroundColor: "rgba(255,255,255,0.98)",
    }),
    option: (styles, state) => {
      const active = state.isSelected || state.isFocused;
      return {
        ...styles,
        borderRadius: "12px",
        padding: "10px 12px",
        fontSize: "14px",
        fontWeight: state.isSelected ? 800 : 600,
        color: brandPalette.secondary,
        backgroundColor: active ? pillOptionHighlightBg : "transparent",
        cursor: "pointer",
        ":active": {
          backgroundColor: "rgba(214, 206, 192, 0.65)",
        },
      };
    },
  };
};
